import { Injectable, inject } from "@angular/core";
import { Actions, ROOT_EFFECTS_INIT, createEffect, ofType } from "@ngrx/effects";
import { forkJoin, map, mergeMap, switchMap } from "rxjs";

// Store
import { Store } from "@ngrx/store";
import * as SportsbookActions from "../../../stores/sportsbook/sportsbook.actions";
import { SportsbookFacade } from "../../../stores/sportsbook/sportsbook.facade";
import { SportsbookState } from "../../../stores/sportsbook/sportsbook.reducers";

// Services
import { DeviceService } from "@services/device.service";
import { SportService } from "@sports-services/sports.service";

@Injectable({ providedIn: "root" })
export class SportsbookInitEffects {
  // Services
  actions$ = inject(Actions);
  sportService = inject(SportService);

  // Utils
  deviceService = inject(DeviceService);
  store = inject(Store<SportsbookState>);
  sportsbookFacade = inject(SportsbookFacade);

  init$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ROOT_EFFECTS_INIT),
      switchMap(() => {
        const gameTypes$ = this.sportService
          .getGameTypesData()
          .pipe(map((gameTypes) => SportsbookActions.setGameTypes(gameTypes)));
        const betsData$ = this.sportService
          .getBetsConfigData()
          .pipe(map((betsData) => SportsbookActions.setBetsData({ betsData })));
        return forkJoin([gameTypes$, betsData$]).pipe(mergeMap((response) => [response[0], response[1]]));
      }),
    ),
  );
}
